import { useState } from 'react';
import style from './lokasiPerumCompoStyle.module.css';
const LokasiPerumCompo = (props) => {
  return (
    <div>
      <div className={`${style['detail-1']} d-flex mb-3`}>
        <div className={`${style.iconKeterangan} d-flex `}>
          <img src={props.icon} alt="" className={style.img} />
          <p>{props.title}</p>
        </div>
        <div className={style.waktu}>
          <p>{props.time}</p>
        </div>
      </div>
    </div>
  );
};
export default LokasiPerumCompo;
